module.exports = __webpack_public_path__ + "img/powered-by-medics-academy.8fda5e59.svg";